// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"62d4b90b","239":"39d69e1a","453":"8b8b2799","732":"3bb51deb"}[chunkId] + ".chunk.js";
};